import { render } from "./TheBattleScreen.vue?vue&type=template&id=f34cd30a&bindings={\"enemyHp\":\"props\",\"myHp\":\"props\",\"currentDir\":\"props\",\"isEnemyShiverActivated\":\"data\",\"isMyShiverActivated\":\"data\",\"weapons\":\"data\",\"positionLeft\":\"options\",\"positionCenter\":\"options\",\"positionRight\":\"options\",\"checkDirHasWeapon\":\"options\"}"
import script from "./TheBattleScreen.vue?vue&type=script&lang=js"
export * from "./TheBattleScreen.vue?vue&type=script&lang=js"

import "./TheBattleScreen.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script